import type { ButtonThemeType, CardThemeType } from "./types"


export type FarmThemeType = {

    claimButton?: ButtonThemeType;
    stakeButton?: ButtonThemeType;
    infoButton?: ButtonThemeType;
    farmCard?: CardThemeType;
    featuredCard?: CardThemeType;
}

export const farmTheme: FarmThemeType = {
    claimButton: {
        color: "secondary",
        size: "md",
    },
    stakeButton: {
        color: "secondary",
    },
    featuredCard: {
        className: "",
    },
}